import React, { useEffect, useState } from 'react';
import { Grid, TextField, Button } from '@mui/material';
import { SearchSm } from '../../../assets';
import { useTranslation } from 'react-i18next';

type FiltersProps = {
  onSearch: (filters: { barcode: string; itemSKU: string }) => void;
  filters: { barcode: string; itemSKU: string }
};

const BarcodeMappingFilters: React.FC<FiltersProps> = ({ onSearch, filters }) => {
  const { t } = useTranslation('barcodeMapping');
  const [barcode, setBarcode] = useState(filters.barcode);
  const [itemSKU, setItemSKU] = useState(filters.itemSKU);

  const handleSearch = () => {
    onSearch({ barcode, itemSKU });
  };

  useEffect(() => {
    setBarcode(filters.barcode);
    setItemSKU(filters.itemSKU);
  }, [filters]);

  const handleClear = () => {
    setBarcode('');
    setItemSKU('');
    onSearch({ barcode: '', itemSKU: '' });
  };

  return (
    <Grid container
      spacing={2}
      sx={{ p: 2 }}
      alignItems="center">
      <Grid item
        xs={12}
        md={2}>
        <TextField
          label={t('barcode')}
          value={barcode}
          onChange={(e) => setBarcode(e.target.value)}
          fullWidth
        />
      </Grid>
      <Grid item
        xs={12}
        md={2}>
        <TextField
          label={t('itemSKU')}
          value={itemSKU}
          onChange={(e) => setItemSKU(e.target.value)}
          fullWidth
        />
      </Grid>
      <Grid item
        xs={12}
        md={2}>
        <Button
          onClick={handleClear}
          variant="secondary"
          size="lg"
          fullWidth
        >
          {t('clear')}
        </Button>
      </Grid>
      <Grid item
        xs={12}
        md={2}>
        <Button
          onClick={handleSearch}
          variant="primary"
          size="lg"
          fullWidth
          startIcon={<SearchSm />}
        >
          {t('search')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default BarcodeMappingFilters;
